import { css } from '@/styled-system/css';

export const backgroundStyles = css.raw({
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  margin: 0,
  flex: 1,
  alignSelf: 'stretch',
});
